import React from 'react';
import { PUBLIC_DOMAIN } from '@constants';

export function RulerItem({ num }: { num: number }) {
  return (
    <div
      className="flex w-60 shrink-0 items-center"
      style={{
        fontSize: 10,
        backgroundImage: `url(${PUBLIC_DOMAIN}/imgs/vh-ruler.e2d325e3317fd62b5cd98a41a39cebee.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '60px 7px',
        backgroundPositionY: 'bottom',
      }}
    >
      {num}
    </div>
  );
}
